module.exports = __webpack_public_path__ + "img/promotion-icon.6b9f3b76.svg";